import { DetailPanelMoveTarget } from 'src/components/dispatch/detailPanel/types';

/** 移動先候補の元になる 1 行。shiftId を引けない行 (placeholder 等) は null */
export type MoveTargetSourceRow = {
  rowId: string;
  vehicleNumber: string;
  driverName: string;
  shiftId: number | null;
  /** FR 合成行など実在する delivery を持たない行。意図を読めるよう明示で受ける */
  isPlaceholderRow?: boolean;
};

/**
 * 「他車両へ配車」の移動先候補を作る。
 *
 * Why not rowId で移動元を弾くだけにしない: 同じ車両の別回転は rowId が違うのに
 * shiftId は同じになる (rowLookup.ts:31-33 が全 cycle を同一 delivery へ写す)。
 * transfer が API へ渡すのは shiftId だけ (Presenter.tsx の transferToShiftId /
 * transferFromShiftId) なので、rowId だけで弾くと「自分から自分へ移す」候補が残る。
 *
 * Why 移動元を解決できないときは空にする: 候補を出しても選んだ後に
 * useDispatchDetailActions:281 で「移動元または移動先の delivery が特定できませんでした」と
 * 失敗するだけ。**選べるのに必ず失敗する選択肢**を作らない。空を返せば器はボタンを描かない。
 */
export function buildMoveTargets(
  rows: MoveTargetSourceRow[],
  source: { currentRowId: string | null; sourceShiftId: number | null },
): DetailPanelMoveTarget[] {
  // 移動元が分からなければ transfer を組み立てられない
  if (source.currentRowId == null || source.sourceShiftId == null) return [];

  const seenShiftIds = new Set<number>();
  const targets: DetailPanelMoveTarget[] = [];

  rows.forEach((row) => {
    if (row.isPlaceholderRow) return;
    // shiftId を引けない行は選んでも moveToVehicle が弾く (useDispatchDetailActions.ts:281)
    if (row.shiftId == null) return;
    if (row.rowId === source.currentRowId) return;
    if (row.shiftId === source.sourceShiftId) return;
    if (seenShiftIds.has(row.shiftId)) return;

    seenShiftIds.add(row.shiftId);
    targets.push({
      rowId: row.rowId,
      // 移動先は shift 単位で回転を区別できないため、回転番号は出さない
      label: row.vehicleNumber,
      subLabel: row.driverName,
    });
  });

  return targets;
}
